import { makeAutoObservable } from "mobx";
import { IRefundSetting } from "../models/User";

interface IRefundSettingChanges extends Partial<IRefundSetting> { };

class RefundSettingStore {
    private _model: IRefundSetting;
    private _changes: IRefundSettingChanges = {};

    constructor(refund_setting: IRefundSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._model = ensureValidModel(refund_setting);
    }

    public get settingField() {
        return this._changes.setting_field ?? this._model.setting_field;
    }

    public get refundType() {
        return this._changes.refund_type ?? this._model.refund_type;
    }

    public get isManualEnabled() {
        return this._changes.is_manual_enabled ?? this._model.is_manual_enabled;
    }

    public get isAutomaticEnabled() {
        return this._changes.is_automatic_enabled ?? this._model.is_automatic_enabled;
    }

    public setIsAutomaticEnabled(v: boolean) {
        this._changes.is_automatic_enabled = v;
        this._clearChangesIfEqual('is_automatic_enabled');
    }

    public setIsManualEnabled(v: boolean) {
        this._changes.is_manual_enabled = v;
        this._clearChangesIfEqual('is_manual_enabled');
    }

    public discardChanges() {
        this._changes = {} as IRefundSetting;
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    private _clearChangesIfEqual(key: keyof IRefundSetting): void {
        if (this._changes[key] === this._model?.[key]) {
            delete this._changes[key];
        }
    }

    public getUpdatedModel(): IRefundSetting {
        return { ...this._model, ...this._changes };
    }

}

export default RefundSettingStore;

function ensureValidModel(data: IRefundSetting): IRefundSetting {
    const toBool = (v: undefined | any) => {
        if (typeof v === 'string') {
            return Boolean(Number(v));
        }
        return Boolean(v);
    };

    return {
        ...data,
        is_automatic_enabled: toBool(data.is_automatic_enabled),
        is_manual_enabled: toBool(data.is_manual_enabled)
    };
}